import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import DynamicBreadcrumb from "../../include/DynamicBreadcrumb";

const DynamicBanner = ({ images = [], buttons = [], heading = "" }) => {
  if (!images.length && !heading) return <></>;
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
  };

  return (
    <div className="alumni_banner">
      <section className="breadcrump_section">
        <Slider {...sliderSettings} className="banner-slider">
          {images.map((img, index) => (
            <div key={index} className="banner-slider">
              <img
                src={
                  img.startsWith("http")
                    ? img
                    : `${process.env.REACT_APP_API_URL}/public/${img}`
                }
                alt={`Banner ${index + 1}`}
                className="img-fluid"
              />
            </div>
          ))}
        </Slider>

        <div className="breadcrump-wrapper">
          <h1 className="breadcrump-heading">{heading}</h1>
          {buttons.length > 0 && (
            <div className="d-flex justify-content-center flex-wrap gap-3 mt-3">
              {buttons.map((btn, idx) => (
                <Link
                  to={btn.link}
                  key={idx}
                  className="btn apply-new-btn"
                  target={btn.target || "_self"}
                  rel="noopener noreferrer"
                >
                  {btn.text}
                </Link>
              ))}
            </div>
          )}
        </div>
        <DynamicBreadcrumb />
      </section>
    </div>
  );
};

export default DynamicBanner;
